import * as React from "react";
import { GenericDialog } from "../../generic-dialog/GenericDialog.component";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MessageService } from "../../../services/message.service";
import { inputService } from "../../../../modules/inputs/input/InputService";
import "./StartTrainingDialog.component.css";
export function StartTrainingDialog() {
    var _a, _b, _c;
    const [isVisible, setIsVisible] = useState(false);
    const confirmFn = useRef(() => { });
    const rejectFn = useRef(() => { });
    const disabledInputId = useRef(undefined);
    const [trainingName, setTrainingName] = useState("");
    const [inputConfig, setInputConfig] = useState();
    const [fieldValues, setFieldValues] = useState(new Map());
    const showStartTrainingDialog = (name, config, onConfirm, onReject) => {
        var _a;
        setTrainingName(name);
        setInputConfig(config);
        const initialValues = new Map();
        for (const entry of (_a = config === null || config === void 0 ? void 0 : config.entries) !== null && _a !== void 0 ? _a : []) {
            if (entry.type === "Checkbox") {
                initialValues.set(entry.id, String(entry.default));
            }
            else if (entry.type === "Select") {
                initialValues.set(entry.id, entry.default);
            }
        }
        setFieldValues(initialValues);
        confirmFn.current = onConfirm;
        rejectFn.current = onReject;
        setIsVisible(true);
    };
    useEffect(() => {
        MessageService.registerGlobalStartTrainingFn(showStartTrainingDialog);
    }, []);
    useEffect(() => {
        const appRootElement = document.getElementById("app-root");
        if (!appRootElement) {
            return;
        }
        if (isVisible) {
            appRootElement.classList.add("start-training-dialog-open");
        }
        else {
            appRootElement.classList.remove("start-training-dialog-open");
        }
        return () => {
            appRootElement.classList.remove("start-training-dialog-open");
        };
    }, [isVisible]);
    useEffect(() => {
        if (isVisible && disabledInputId.current === undefined) {
            disabledInputId.current = inputService.setDisabled();
        }
        else if (!isVisible && disabledInputId.current !== undefined) {
            inputService.setEnabled(disabledInputId.current);
            disabledInputId.current = undefined;
        }
        return () => {
            if (disabledInputId.current !== undefined) {
                inputService.setEnabled(disabledInputId.current);
                disabledInputId.current = undefined;
            }
        };
    }, [isVisible]);
    const confirm = () => {
        setIsVisible(false);
        confirmFn.current(fieldValues);
    };
    const reject = () => {
        setIsVisible(false);
        rejectFn.current();
    };
    const updateField = (id, value) => {
        setFieldValues(prev => new Map(prev).set(id, value));
    };
    const title = (_a = inputConfig === null || inputConfig === void 0 ? void 0 : inputConfig.title) !== null && _a !== void 0 ? _a : `Willkommen im ${trainingName} Training von PharmaXR`;
    const fieldEntries = ((_b = inputConfig === null || inputConfig === void 0 ? void 0 : inputConfig.entries) !== null && _b !== void 0 ? _b : []);
    return (React.createElement(React.Fragment, null, isVisible && (React.createElement(GenericDialog, { title: title, confirmText: "Starte das Szenario in VR", cancelText: "Als Zuschauer beitreten", onCancel: reject, onConfirm: confirm, width: "narrow", allowBackgroundInteraction: true, stackLevel: "low" },
        React.createElement("div", { className: fieldEntries.length === 0 ? "confirm-dialog-content" : "start-training-dialog-content" }, fieldEntries.length === 0 ? (React.createElement(React.Fragment, null,
            React.createElement(FontAwesomeIcon, { icon: ["fas", "user-astronaut"], size: "2x", className: "info-color" }),
            React.createElement("span", { className: "confirm-dialog-question" }, (_c = inputConfig === null || inputConfig === void 0 ? void 0 : inputConfig.text) !== null && _c !== void 0 ? _c : "Möchten Sie das Szenario jetzt starten?"))) : (React.createElement(React.Fragment, null,
            (inputConfig === null || inputConfig === void 0 ? void 0 : inputConfig.text) !== undefined && (React.createElement("span", { className: "start-training-dialog-text" }, inputConfig.text)),
            React.createElement("div", { className: "start-training-fields" }, fieldEntries.map(entry => {
                var _a;
                if (entry.type === "Checkbox") {
                    return (React.createElement("div", { key: entry.id, className: "start-training-field-row" },
                        React.createElement("label", { className: "start-training-field-label" }, entry.label),
                        React.createElement("input", { type: "checkbox", checked: fieldValues.get(entry.id) === "true", onChange: (ev) => { updateField(entry.id, String(ev.target.checked)); } })));
                }
                if (entry.type === "Select") {
                    return (React.createElement("div", { key: entry.id, className: "start-training-field-row" },
                        React.createElement("label", { className: "start-training-field-label" }, entry.label),
                        React.createElement("select", { value: (_a = fieldValues.get(entry.id)) !== null && _a !== void 0 ? _a : entry.default, onChange: (ev) => { updateField(entry.id, ev.target.value); } }, entry.options.map(opt => React.createElement("option", { key: opt, value: opt }, opt)))));
                }
                return null;
            })))))))));
}
